import React from "react";
import Indusone from "../../images/EXPLORE DIVISIONS/depositphotos_82411686-stock-photo-power-tools-aisle-in-a.jpg";

function OurExpertise() {
  return (
    <div className="w-full">
      {/* Top Section - Image & Text */}
      <div className="mx-auto md:mt-3">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-3 items-stretch">
          {/* Left Side - Text Content */}
          <div className="lg:col-span-5 bg-white text-[#0c2340] p-6 rounded-lg duration-300 ease-in-out flex flex-col justify-center md:h-[400px]">
            <h2 className="text-2xl md:text-4xl font-bold mb-2 md:mb-4 text-center">
            ADHESIVES DIVISION
            </h2>
            <p className="text-sm md:text-lg md:mt-2 mb-6 text-justify">
            Adhesives offers innovative bonding solutions that cater to the needs of construction, manufacturing, and woodworking industries. Our advanced adhesive technologies, including epoxy, polyurethane, and cyanoacrylate, are engineered to deliver high-strength bonds that ensure lasting performance in even the most demanding environments. These adhesives are designed for fast curing, providing quick turnaround times for projects while maintaining robust structural integrity. Additionally, our adhesives offer resistance to heat, chemicals, and moisture, making them ideal for a wide range of applications that require durability and reliability.
            </p>
          </div>

          {/* Right Side - Image */}
          <div className="lg:col-span-7 flex">
            <div className="w-full h-[400px] overflow-hidden rounded-lg">
              <img
                src={Indusone}
                alt="Offshore Industry"
                className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-110"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurExpertise;
